<div id="barwrapper">
  <div id="barholder" #wrapper>
    @for (bar of bars; track bar; let i = $index) {
      <div
        [ngStyle]="{ width: ((bar.end - bar.start) / progressbarwidth) * 100 + '%', 'margin-left': bar.margin + '%' }"
        style="position: absolute; height: inherit; display: inline-block"
        (click)="barclick(bar)">
        <clr-tooltip style="width: 100%; height: inherit; display: inline-block">
          @if (hasProfil) {
            <div
              clrTooltipTrigger
              class="bar cursor-pointer"
              (click)="openProfileAt(bar.start_m)"
              (contextmenu)="open($event, bar); $event.preventDefault()"
              (mouseover)="onMouseOver(bar)"
              (mouseleave)="onMouseLeave(bar)"
              [ngStyle]="{ 'background-color': bar.color, border: '0px solid', '--fk': bar.fk }"></div>
          }
          @if (!hasProfil) {
            <div
              clrTooltipTrigger
              class="bar cursor-pointer"
              [ngStyle]="{ 'background-color': bar.color, border: '0px solid', '--fk': bar.fk }"></div>
          }
          <clr-tooltip-content *clrIfOpen [clrPosition]="bar.tTipPos" clrSize="lg" [innerHTML]="bar.metastring" />
        </clr-tooltip>
        <ng-template #userMenu let-user>
          <section class="user-menu">
            <div (click)="clickProfil()">{{ 'zeige Schienenscan' | mrTranslate }}</div>
          </section>
        </ng-template>
      </div>
    }
    @if (indexScrub >= 0) {
      <div
        class="bar scrub"
        [ngStyle]="{ 'margin-left': ((indexScrub * ratio) / progressbarwidth) * 100 + '%' }"
        style="
          width: 1px;
          background-color: #000;
          transition: none;
          border: 0px solid transparent;
          transform: scale(1, 1.38);
          display: inline-block;
        "></div>
    }
  </div>
  <div id="barlegend">
    @for (val of barlegend; track val) {
      <div [ngStyle]="{ left: (100 / (barlegend.length - 1)) * val + '%' }" class="legendstripe translate-left">
        |
        <br />
        {{ _von + (dist / (barlegend.length - 1)) * val | number: '1.2-2' }}m
      </div>
    }
  </div>
</div>
